import {Row, Container, Col} from 'react-bootstrap'
const groupTypes = {
  Row, Container, Col
}

export {groupTypes}